import { TAnswer, TAnswers } from 'models/common.model'
import { IConfig, IFirebaseConfig } from 'models/config.model'
import { IAppState } from 'models/store.model'
import { IVariant } from 'models/variant.model'
import { Cohort, ScreenName, OptionValue } from 'root-constants'
import { ISubscription } from 'models/subscriptions.model'

export const selectIsFetching = (state: IAppState): boolean =>
  state.common.isFetching
export const selectActionList = (state: IAppState): string[] =>
  state.common.actionList
export const selectError = (state: IAppState): any => state.common.error
export const selectCurrentVariant = (state: IAppState): IVariant | null =>
  state.common.currentVariant || null
export const selectCurrentVariantCohort = (state: IAppState): Cohort | null =>
  state.common.currentVariant?.cohort || null
export const selectHasCancelOffer = (state: IAppState): boolean =>
  state.common.currentVariant?.hasCancelOffer || false
export const selectFacebookPixelId = (state: IAppState): string =>
  state.common.currentVariant?.facebookPixelId || ''
export const selectSubscriptionList = (state: IAppState): ISubscription[] =>
  state.common.subscriptions || []
export const selectConfig = (state: IAppState): IConfig | null =>
  state.common.config
export const selectAmplitudeApiKey = (state: IAppState): string | null =>
  state.common.config?.amplitudeApiKey || null
export const selectGiaApiKey = (state: IAppState): string | null =>
  state.common.config?.giaApiKey || null
export const selectFirebaseConfig = (
  state: IAppState,
): IFirebaseConfig | null => state.common.config?.firebaseConfig || null
export const selectGoogleOptimizeId = (state: IAppState): string | null =>
  state.common.config?.googleOptimizeId || null
export const selectGoogleAnalyticsId = (state: IAppState): string | null =>
  state.common.config?.googleAnalyticsId || null
export const selectStripePublicKey = (state: IAppState): string | null =>
  state.common.config?.stripePublicKey || null
export const selectAnswers = (state: IAppState): Partial<TAnswers> | null =>
  state.common.answers
export const selectPayPalClientId = (state: IAppState): string | null =>
  state.common.config?.payPalClientId || null
export const selectOptimizeExperimentMap = (
  state: IAppState,
): Record<string, string> | null =>
  state.common.currentVariant?.optimizeExperimentMap || null
export const selectOptimizeMap = (
  state: IAppState,
): Record<string, Record<string, string>> | null =>
  state.common.currentVariant?.optimizeMap || null
export const selectOptimizeVariantMap = (
  state: IAppState,
): Record<string, string> | null => state.common.optimizeVariantMap || null
export const selectAbSegmentName = (state: IAppState): string =>
  state.common.currentVariant?.abSegmentName || ''
export const selectScreenName = (state: IAppState): ScreenName =>
  state.common.screenName
export const selectFeelNervousAnswer = (state: IAppState): TAnswer =>
  state.common.answers?.feel_nervous || OptionValue.NOT_AT_ALL
